import styled from '@emotion/styled';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.section`
  display: flex;
  color: #e4e4e4;
  justify-content: space-between;
`;

export const TextWrapper = styled.div``;

export const Title = styled.h1`
  margin: 0;
  ${DESKTOP} {
    font-size: 24px;
    br {
      display: none;
    }
  }
`;

export const ShareButton = styled.button`
  width: 142px;
  height: 43px;
  display: flex;
  border: none;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 16px;
  color: #e4e4e4;
  background-color: #284160;
  cursor: pointer;
  ${DESKTOP} {
    width: 204px;
    height: 54px;
    font-size: 18px;
  }
`;

export const ShareImg = styled.div`
  position: relative;
  margin-left: 8px;
  width: 18px;
  height: 18px;
  ${DESKTOP} {
    width: 20px;
    height: 20px;
  }
`;
